// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-side-to-side[data-v-633ade20] { /* Safari */\n  position: sticky;\n  top: 0;\n  height: 100%;\n  max-height: 100vh;\n  width: 100%;\n}\n.file-side-to-side iframe[data-v-633ade20] {\n  width: 100%;\n}\n.file-side-to-side i[data-v-633ade20] {\n  margin-right: 7px;\n  margin-top: 8px;\n}", ""]);
// Exports
module.exports = exports;
